import qs from 'qs';

type Options = {
  params?: Record<string, unknown>;
  local?: boolean;
};

const joinParts = (parts: (string | undefined)[]) => {
  return parts
    .filter((e): e is string => !!e)
    .map((part, i) => {
      if (i === 0) {
        return part.trim().replace(/[\/]*$/g, '');
      } else {
        return part.trim().replace(/(^[\/]*|[\/]*$)/g, '');
      }
    })
    .filter((x) => x.length)
    .join('/');
};

const getParams = (params: Options['params']) => {
  return qs.stringify(params);
};

export const joinUrl = (
  parts: (string | undefined)[],
  { params, local }: Options = {},
) => {
  let url = joinParts(parts);
  if (local && !url.startsWith('/')) {
    url = `/${url}`;
  }
  const paramStr = getParams(params);
  return `${url}${paramStr ? '?' : ''}${paramStr}`;
};
